module.exports = __webpack_public_path__ + "img/ordering-active.ce2f9413.svg";